<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Actualizar roles en contratos')">
        <section class="container">
          <h1>Actualizar <b style="color:black">sólo roles</b> en contratos</h1>
          <br>
          <div  id="drop" @drop="handleDrop" @dragover="handleDragover" @dragenter="handleDragover">
            Arrastre su archivo aquí (.xlsx)
          </div>
        </section>
        <div>
          <h4 style="margin-bottom: 0px;">Columnas ocultas ({{hidden.length}})</h4>
          <ul>
            <li v-for="(v,k) in hidden" :key="k" @click="hidden.splice(hidden.indexOf(v), 1)">
              {{v}}
            </li>
          </ul>
        </div>
        <div style="margin-bottom: 7px;">
          <b style="color:red">Rojo:</b> son los contratos no encontrados o más de 1 con el mismo nombre
        </div>
        <div style="margin-bottom: 7px;">
          <b style="color:blue">Azul:</b> son los nombres de usuario no encontrados
        </div>
        <div style="margin-bottom: 7px;">
          <b style="color:green">Verde:</b> son los usuarios que ya están asignados en esa posición
        </div>
        <div style="margin-bottom: 7px;">
          <b class="textOrange">Naranja:</b> son los campos requeridos
        </div>
        <div>
          <br>
          <b>Sólo los que se editarán</b> <input style="margin-left: 10px;" type="checkbox" v-model="onlyEditable"/>
        </div>
        <div style="overflow-x:scroll;width: 100%;height:500px; margin-top: 30px;">
          <table class="tableUpdateContractRoles">
            <thead>
              <tr>
                <template  v-for="(key,i) in filteredHeaders">
                  <th style="padding: 5px;" @click="hidden.push(key)" :key="i">
                    <span :class="isNeededTh(key) && 'textOrange'">

                      {{key}}
                    </span>
                  </th>
                </template>
                <th style="padding: 5px;">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, k) in tickets">
                
                <tr v-if="!onlyEditable || item.toEdit" :key="k">
                  <template v-for="(key,kk) in filteredHeaders">
                    <td style="padding: 5px;" :key="kk"  :class="!findContract(item['Contrato']) && 'textRed'">

                      <span v-if="key === 'Contrato'">{{item[key]}}</span>
                      <span v-else-if="isUserColumn(key)" :class="usserColor(item, key)">
                        {{item[key]}}
                      </span>
                      <span v-else>{{item[key]}}</span>

                    </td>
                  </template>
                  <td style="padding: 5px;">
                    <span v-if="item.status === -1" class="textRed">Error!</span>
                    <span v-if="item.status === 0"></span>
                    <span v-if="item.status === 1" class="textGreen">Editado!</span>
                  </td>
                </tr>
              </template>

            </tbody>
          </table>
        </div>
        <br>
        <div>
          <el-button type="primary" size="small" icon="el-icon-refresh" @click="save">Aplicar cambios</el-button>
        </div>
        <br>
        <div>
          <ul>
            <li>Luego de aplicar los cambios debe recargar la página</li>
            <li>La columna estado indica si se logró realizar la modificación</li>
          </ul>
        </div>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import XLSX from 'xlsx';
import axios from 'axios';

var state={
    tickets:[{name:"test"}],
    headers:["Test header"],
    hidden:[],
    onlyEditable:false,
    neededHeaders: {
      exactly: [
        'Contrato',
      ],
      mustInclude: [
        'contractor_hse',
        'contract_owner',
        'administrator',
        'contractor_coordinator',
        'hse',
        'health',
        'safety',
        'environment',
        'contractor_hse',
        'owner',
        'contract_owner',
        'risk',
        'administrator',
        'contractor_coordinator',
        'coordinator',
      ]
    },
  }
/** HELPERS **/
function get_header_row(sheet) {
    var headers = [], range = XLSX.utils.decode_range(sheet['!ref']);
    var C, R = range.s.r; /* start in the first row */
    for(C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        var cell = sheet[XLSX.utils.encode_cell({c:C, r:R})] /* find the cell in the first row */
        var hdr = "UNKNOWN " + C; // <-- replace with your desired default 
        if(cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
    }
    return headers;
}
function fixdata(data) {
	var o = "", l = 0, w = 10240;
	for(; l<data.byteLength/w; ++l) o+=String.fromCharCode.apply(null,new Uint8Array(data.slice(l*w,l*w+w)));
	o+=String.fromCharCode.apply(null, new Uint8Array(data.slice(l*w)));
	return o;
}
function workbook_to_json(workbook) {
	var result = {};
	workbook.SheetNames.forEach(function(sheetName) {
		var roa = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
		if (roa.length > 0) result[sheetName] = roa;
	});
	return result;
}
/** PARSING and DRAGDROP **/


function handleDragover(e) {
	e.stopPropagation();
	e.preventDefault();
	e.dataTransfer.dropEffect = 'copy';
}

export default {
  data() {
    return state;
  },
  async created() {
    if (!this.faenas.length) this.$store.dispatch('getContractsFaena');
    if (!this.users.length) this.$store.dispatch('getUsersFaena', this.faena_id);
  },
  computed: {
    faena_id() { return this.$store.getters.role.faena_id },
    faenas() { return this.$store.getters.faenas },
    contracts() { return this.$store.getters.contracts },
    users() { return this.$store.getters.usersFaena },
    filteredHeaders() {
      return this.headers.filter(h => !this.hidden.includes(h))
    },
  },
  methods: {
    handleDragover:handleDragover,
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
        console.log("DROPPED");
      var files = e.dataTransfer.files, i, f;
      for (i = 0, f = files[i]; i != files.length; ++i) {
        var reader = new FileReader(),
        name = f.name;
        var $this = this;
        reader.onload = function(e) {
          var results, 
          data = e.target.result, 
          fixedData = fixdata(data), 
          workbook=XLSX.read(btoa(fixedData), {type: 'base64'}), 
          firstSheetName = workbook.SheetNames[0], 
          worksheet = workbook.Sheets[firstSheetName];
          state.headers=get_header_row(worksheet);
          results=XLSX.utils.sheet_to_json(worksheet);
            console.log(results)

          state.headers.forEach(h => {
            let isNeeded = false
            for(const nh of state.neededHeaders.mustInclude) {
              if (h.includes(nh)){
                isNeeded = true;
                break;
              }
            }
            for(const nh of state.neededHeaders.exactly) {
              if (h === nh){
                isNeeded = true;
                break;
              }
            }
            if (!isNeeded) state.hidden.push(h)

          })



          results.forEach(rw => {
            rw.status = 0;
            rw.toEdit = false;
            const con = $this.findContract(rw.Contrato);
            if (!con) return false;
            for(const h of $this.filteredHeaders) {
              for(const nh of $this.neededHeaders.mustInclude) {
                if (h.includes(nh)){
                  const users = $this.filterUser(rw[h]);
                  if (users.length !== 1) break;
                  const {ok, key, pos} = $this.getKeyPos(h);
                  if (ok) {
                    if (con.revisores[key][pos] !== users[0]._id) {
                      rw.toEdit = true;
                      rw.con = con;
                      break;
                    }
                  } // if
                } // if
              } // for
            } // for
          });


          state.tickets=results;

        };
        reader.readAsArrayBuffer(f);
      }
    },
    findContract(name) {
      const cons = this.contracts.filter(c => c.nombre == name);
      if (cons.length > 1) {
        return false;
      }
      if (cons.length === 1) return cons[0];
      return false;
    },
    filterUser(name) {
      return this.users.filter(u => `${u.nombre} ${u.apellido}` === name); 
    },
    save() {
      const list = [];
      this.tickets.filter(rw => rw = rw.toEdit).forEach(rw => {
        const {con} = rw;
        for(const h of this.filteredHeaders) {
          for(const nh of this.neededHeaders.mustInclude) {
            if (h.includes(nh)){
              const users = this.filterUser(rw[h]);
              if (users.length !== 1) break;
              const {ok, key, pos} = this.getKeyPos(h);
              if (ok) {
                if (con.revisores[key][pos] !== users[0]._id) {
                  con.revisores[key][pos] = users[0]._id;
                  break;
                }
              } // if
            } // if
          } // for
        } // for
        list.push(rw)
      });
      
      
      list.forEach(async rw => {
        await this.send(rw)
      })
        //this.send(list[0])
      console.log(list)
    },
    async send(rw) {
      const id = rw.con._id;
      const { revisores } = rw.con;
      return await this.editContract({ id, body: {revisores} })
        .then(r => rw.status = r? 1: -1)
        .catch(e => {
          console.error(e);
          rw.status = -1;
        });
    },
    usserColor(rw, key) {
      const users = this.filterUser(rw[key]);
      if (users.length === 0) return 'textBlue';
      if (users.length > 1) return 'textPurple';
      if (this.isUserIn(rw, key, users[0])) return 'textGreen';
      return;
    },
    isUserIn(rw, h, user) {
      const {ok, key, pos} = this.getKeyPos(h);
      if (ok) {
        const con = this.findContract(rw.Contrato)
        if (!con) return false;
        return con.revisores[key][pos] === user._id;
      }
      return false;
    },
    isUserColumn(h) {
      const {ok} = this.getKeyPos(h);
      return ok;
    },
    isNeededTh(th){
      let isNeeded = false
      for(const nh of this.neededHeaders.mustInclude) {
        if (th.includes(nh)){
          isNeeded = true;
          break;
        }
      }
      for(const nh of this.neededHeaders.exactly) {
        if (th === nh){
          isNeeded = true;
          break;
        }
      }
      return isNeeded;
    },
    getKeyPos(h) {
      const array = h.split(' ');
      const key = array[0];
      const pos = parseInt(array[1]) - 1;
      if (this.neededHeaders.mustInclude.includes(key) && [0, 1].includes(pos)) {
        return {ok:true, key, pos}
      } else {
        return {ok:false, key, pos}
      } // if
    },
    async editContract(contract) {
      const SERVICE_URL_CONTRACTS = '/contratos';
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      };
      return await axios
        .post(`${SERVICE_URL_CONTRACTS}/editContract/${contract.id}`, contract.body, config)
        .then((r) => !!r.data.success)
    },
  }
};
</script>

<style scoped>
#drop{
  border: 2px dashed #bbb;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  padding: 25px;
  text-align: center;
  font: 20pt bold,"Vollkorn";
  color: #bbb;
}
.tableUpdateContractRoles th{
  background: lightgray;
}
.tableUpdateContractRoles td,
.tableUpdateContractRoles th{
  border: solid 1px;
}
.textRed { color: red; }
.textBlue { color:blue; }
.textGreen { color: green; }
.textOrange { color: rgb(216, 120, 3); }
.textPurple { color:darkviolet }
</style>
